import React from 'react'
import { IPostData } from 'app-lib/apis/ghostApi'
import ExternalLink from 'shared-components/ExternalLink'

export const OokiversityPost = ({ post }: { post: IPostData }) => {
  const prefix = 'Ookiversity: '
  const postTitle = post.title.startsWith(prefix) ? post.title.slice(prefix.length) : post.title
  return (
    <div className="margin-bottom-1" key={post.url}>
      <ExternalLink href={post.url} className="margin-bottom-1 width-100p">
        <img
          src={post.image}
          title={post.title}
          className="learn__blog-post__img width-100p panel--simple"
        />
      </ExternalLink>

      <div>
        <ExternalLink href={post.url}>
          <h4 className="h4 txt-size-12 txt-default link--hover margin-0" data-testid={'title'}>
            {postTitle}
          </h4>
        </ExternalLink>

        <p className="txt-subtitle">{post.date}</p>
        <p className="margin-0 txt-explanation">
          {post.excerpt.replaceAll('\n', ' ').slice(0, 180)}…{' '}
          <ExternalLink className="link--discreet" href={post.url}>
            read more
          </ExternalLink>
        </p>
      </div>
    </div>
  )
}

export default React.memo(OokiversityPost)
